import React, { useEffect, useState } from 'react';
import { FocusedLayout } from '../../components/layout/FocusedLayout';
import { userAPI } from '../../services/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { toast } from 'sonner';
import { formatDate } from '../../utils/helpers';
import { Bell } from 'lucide-react';

export const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    userAPI.getNotifications()
      .then(res => setNotifications(res.data))
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <FocusedLayout title="Notifications">
      <div className="space-y-6" data-testid="notifications-page">
        <div>
          <h1 className="text-4xl font-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>Notifications</h1>
          <p className="mt-2 text-muted-foreground">Recent platform activity and alerts</p>
        </div>

        {loading ? (
          <Card><CardContent className="py-12 text-center">Loading...</CardContent></Card>
        ) : notifications.length === 0 ? (
          <Card>
            <CardContent className="py-12 text-center space-y-3">
              <Bell className="h-12 w-12 mx-auto text-muted-foreground" />
              <p className="text-muted-foreground">No notifications yet</p>
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-2">
            {notifications.map(n => (
              <Card key={n.id} className={!n.read ? 'border-blue-500' : ''}>
                <CardContent className="pt-4">
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <p className="font-medium">{n.title}</p>
                        {!n.read && <Badge className="bg-blue-600 text-xs">New</Badge>}
                      </div>
                      <p className="text-sm text-muted-foreground">{n.message}</p>
                    </div>
                    <span className="text-xs text-muted-foreground">{formatDate(n.created_at)}</span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </FocusedLayout>
  );
};
